import { Controller } from "stimulus";
import Rails from "@rails/ujs";

export default class extends Controller {
  static targets = ['content', 'form'];

  static values = {
    qualificationId: String
  }

  connect() {
    this._boundOpenEditor = this._openEditor.bind(this);
    this._boundCloseEditor = this._closeEditor.bind(this);

    document.addEventListener('promote:open-qualification-users-editor', this._boundOpenEditor);
    document.addEventListener('promote:close-qualification-users-editor', this._boundCloseEditor);
  }

  disconnect() {
    document.removeEventListener('promote:open-qualification-users-editor', this._boundOpenEditor);
    document.removeEventListener('promote:close-qualification-users-editor', this._boundCloseEditor);
  }

  async verifyFormsAndClose() {
    try {
      await this.verify();
      this._boundCloseEditor();
    } catch (e) {
      // no-op
    }
  }

  async verify() {
    const unloadChecker = this.application
      .getControllerForElementAndIdentifier(document.body, "unload-checker");

    return await unloadChecker.verify();
  }

  get panelEditorController() {
    return this.application.getControllerForElementAndIdentifier(this.element, 'panel-editor');
  }

  _openEditor() {
    this.panelEditorController.openPanel(this.verifyFormsAndClose.bind(this));
  }

  _closeEditor() {
    this.panelEditorController.closePanel();
  }
}
